import { HttpClient } from '@angular/common/http';
import { MyReaction, ReactionInfo } from '@app/shared/models/post';
import { environment } from '@env/environment';
import { Observable, catchError, map, timeout } from 'rxjs';
import { ApiClientConfig } from '../api-client.config';
import { MyReactionsByEntityIdResponse, ReactionArrayResponse, ReactionResponse } from './api.reactions.model';

export class ReactionsApi {
  private apiUrl: string = environment.API_URL;
  REACTIONS = '/reactions/reactions';
  constructor(
    public readonly httpClient: HttpClient,
    public config: ApiClientConfig
  ) {}

  getReactionsByEntityId(entityId: string, reactionType: string): Observable<ReactionInfo[]> {
    let url = `${this.REACTIONS}/${entityId}`;
    if (reactionType !== '') {
      url += `?reactionType=${reactionType}`;
    }
    return this.httpClient.get<ReactionArrayResponse>(`${this.apiUrl}${url}`).pipe(
      timeout(this.config.responseTimeout),
      map((res: ReactionArrayResponse) => {
        return res.data;
      }),
      catchError(error => {
        throw error.error;
      })
    );
  }

  getMyReactionsByEntityId(entityId: string): Observable<MyReaction> {
		return this.httpClient
			.get<MyReactionsByEntityIdResponse>(`${this.apiUrl}${this.REACTIONS}/${entityId}/my-reaction`)
			.pipe(
				timeout(this.config.responseTimeout),
				map((res: MyReactionsByEntityIdResponse) => {
					return res.data;
				}),
				catchError(error => {
					throw error.error;
				})
			);
	}

  deleteReactions(reactionId: string) {
		return this.httpClient
			.delete<ReactionResponse>(`${this.apiUrl}${this.REACTIONS}/${reactionId}`)
			.pipe(catchError(error => {
				throw error.error;
			}));
	}

  postReactions(body: any): Observable<ReactionInfo> {
		return this.httpClient
			.post<ReactionResponse>(`${this.apiUrl}${this.REACTIONS}`, body)
			.pipe(
				timeout(this.config.responseTimeout),
				map((res: ReactionResponse) => {
					return res.data;
				}),
				catchError(error => {
					throw error.error;
				})
			);
	}
}
